export default {
  withus: '走进我们',
  mission: '我们的使命',
  missiontext: '世界与我们在一起，让人人享用清洁电力',
  vision: '我们的愿景',
  visiontext: '绿色是无价的，成为清洁电力转换技术全球引领者',
  values: '核心价值观',
  sincerity: '诚恳务实 严谨开放 创新尊重 成就客户',
  energytitle: '绿色能源，让世界增加绿色动力，让人人享用清洁电力',
  energytext:
    '是我们的事业使命和底层信念，随着以新能源为主体的新型电力系统加速发展，绿电逐渐走进千行百业、千家万户，通往清洁能源未来的道路充满机遇与挑战',
  journey: '我们的发展历程',
  power: '2025开始布局AIDC电源业务',
  brandvalue: '2023-2024品牌价值突破百亿元',
  inverters: '2019-2023研制逆变器并网发电',
  photovoltaic: '2017-2018研制中压直挂光伏逆变器',
  cpname: '寰能数航科技（深圳）有限公司',
  cptext: `寰能数航科技（深圳）有限公司,成立于2003年，是一家全球领先、创新驱动的工业科技公司。寰能数航技术依托在自动化、数字化、智能化领域的深厚技术积淀，构建起工业自动化与数字化、新能源汽车动力系统、智能机器人、数字能源四大技术同源、协同发展的业务生态，致力于为全球客户提供智能、高效、绿色、安全的综合产品和解决方案。总部位于深圳，生产基地位于东莞、苏州、等地。 寰能数航技术聚焦工业领域的自动化、数字化、智能化，在"数字层、边缘层、控制层、驱动层、执行层、传感层"形成贯通式布局，持续为工业客户提供"用得起、用得好、易部署、易升级"的数自融合解决方案。`,
  phone: '联系电话: 0755-25478456',
  addr: '地址：深圳市福田区沙头街道天安社区深南大道6021号喜年中心A单元1008C-20',
};
